import React, {
  useCallback,
  useMemo, useRef, useState,
} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import {
  IconButton, Input, Menu, MenuItem,
} from '@mui/material';

function DateInput({
  value,
  onChange,
  disabled,
  readOnly,
  variants,
  id,
  margin,

}) {
  const [menuOpened, setMenuOpened] = useState(false);
  const inputRef = useRef();
  const variantSelected = variants && !!variants.filter((v) => v.value === value).length;
  const displayValue = useMemo(
    () => {
      if (!value) return null;
      if (variantSelected) {
        return variants.filter((v) => v.value === value).reduce((R, r) => r.display_name, '');
      }
      const d = new Date(value);
      const t = d.toJSON();
      if (t) return t.slice(0, 10);
      return null;
    },
    [value, variantSelected, variants],
  );
  const type = variantSelected ? 'text' : 'date';
  const errored = displayValue === null;
  const displayVariants = useMemo(
    () => {
      if (variantSelected && variants && variants.length) return [...variants, { value: null, display_name: 'Довільна дата' }];
      if (!variants) return [];
      return variants;
    },
    [variantSelected, variants],
  );
  const onSelectVariant = useCallback(
    (e, v) => {
      setMenuOpened(false);
      if (v) {
        onChange(e, v);
      } else {
        onChange(e, new Date().toISOString()
          .slice(0, 10));
      }
    },
    [onChange],
  );
  return (
    <>
      <Input
        id={id}
        value={displayValue}
        type={type}
        onChange={(e) => onChange(e, e.target.value)}
        ref={inputRef}
        disabled={disabled}
        readOnly={readOnly || variantSelected}
        endAdornment={variants && variants.length && (
          <IconButton size="small" onClick={() => setMenuOpened(true)} disabled={disabled || readOnly}>
            <FontAwesomeIcon icon={faCaretDown} />
          </IconButton>
        )}
        fullWidth
        error={errored}
        margin={margin}
      />
      <Menu
        anchorEl={inputRef.current}
        open={menuOpened}
        onClose={() => setMenuOpened(false)}
      >
        {displayVariants.map((variant) => (
          <MenuItem
            key={variant.value}
            selected={variant.value === value}
            onClick={(e) => onSelectVariant(e, variant.value)}
          >
            {variant.display_name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

DateInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  variants: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    display_name: PropTypes.string,
  })),
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
};

DateInput.defaultProps = {
  id: null,
  value: null,
  disabled: false,
  readOnly: false,
  variants: null,
  margin: 'dense',
};

export default DateInput;
